import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'delete-contract-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, TranslateModule],
    templateUrl: './delete-contract-dialog.component.html',
})
export class DeleteContractDialogComponent {
    constructor(public dialogRef: MatDialogRef<DeleteContractDialogComponent>) {}

    public confirm(): void {
        this.dialogRef.close(true);
    }

    public cancel(): void {
        this.dialogRef.close(false);
    }
}
